import { MobileNumber } from 'types'

const getMobileNumber = (mobileNumber: MobileNumber) => {
	return `+${mobileNumber.code}${mobileNumber.mobile}`
}

export default getMobileNumber
